import { render, staticRenderFns } from "./RecordsEdit.vue?vue&type=template&id=6dcb819a&"
import script from "./RecordsEdit.vue?vue&type=script&lang=js&"
export * from "./RecordsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dcb819a')) {
      api.createRecord('6dcb819a', component.options)
    } else {
      api.reload('6dcb819a', component.options)
    }
    module.hot.accept("./RecordsEdit.vue?vue&type=template&id=6dcb819a&", function () {
      api.rerender('6dcb819a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/DnsEditor/RecordsEdit.vue"
export default component.exports